import { render, staticRenderFns } from "./TheTeacherEdit.vue?vue&type=template&id=58ff2e38&scoped=true&"
import script from "./TheTeacherEdit.vue?vue&type=script&lang=js&"
export * from "./TheTeacherEdit.vue?vue&type=script&lang=js&"
import style0 from "./TheTeacherEdit.vue?vue&type=style&index=0&id=58ff2e38&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ff2e38",
  null
  
)

export default component.exports